<template>
  <v-container fluid>
    <ActionBar />

    <div class="page__content">
      <v-tabs
        v-model="activeTab"
        slider-color="secondary"
        class="v-tabs-reports"
        :class="{ 'v-tabs-reports__hidden': !isAdminProfile }"
      >
        <v-tab v-if="hasRole('companyGroup', 'ROLE_GET_COMPANYGROUP')" ripple>
          {{ $t(`${namespace}.tabs.companiesGroup`) }}
        </v-tab>

        <v-tab ripple>
          {{ $t(`${namespace}.tabs.companies`) }}
        </v-tab>

        <v-tab v-if="isAdminProfile" ripple>
          {{ $t(`${namespace}.tabs.disabledCompanies`) }}
        </v-tab>

        <v-tab v-if="hasRole('anonymization', 'ROLE_GET_LGPD_ANONYMIZATION_REQUEST')" ripple>
          {{ $t(`${namespace}.tabs.anonymousCompanies`) }}
        </v-tab>

        <v-tabs-items touchless>
          <v-tab-item>
            <CompaniesGroup
              v-if="hasRole('companyGroup', 'ROLE_GET_COMPANYGROUP') && activeTab === 0"
              :activeTab="activeTab"
            />
          </v-tab-item>

          <v-tab-item>
            <Companies v-if="activeTab === 1" />
          </v-tab-item>

          <v-tab-item>
            <DisabledCompanies v-if="isAdminProfile && activeTab === 2" />
          </v-tab-item>

          <v-tab-item>
            <AnonymousCompanies v-if="hasRole('anonymization', 'ROLE_GET_LGPD_ANONYMIZATION_REQUEST') && activeTab === 3" />
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </div>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import { isObject, hasRole } from 'utils/functions'
import ActionBar from 'components/company/ActionBar'
import Companies from 'components/company/companies'
import CompaniesGroup from 'components/company/companiesGroup'
import DisabledCompanies from 'components/company/disabledCompanies'
import AnonymousCompanies from 'components/company/anonymousCompanies'

export default {
  name: 'CompanyPage',
  components: {
    ActionBar,
    Companies,
    CompaniesGroup,
    DisabledCompanies,
    AnonymousCompanies
  },
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany
    }),

    isAdminProfile () {
      return hasRole('profiles', 'ROLE_ADMINISTRATOR') || hasRole('profiles', 'ROLE_FINANCIAL_ADMIN')
    },

    tabUrlParam () {
      return this.$route.query && this.$route.query.tab
        ? this.$route.query.tab
        : null
    }
  },
  data () {
    return {
      namespace: 'Views.CompanyPage',
      activeTab: (hasRole('profiles', 'ROLE_ADMINISTRATOR') || hasRole('profiles', 'ROLE_FINANCIAL_ADMIN')) ? 0 : 1
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    },

    isValidObject (val) {
      return isObject(val)
    },

    redirectToCompany (company) {
      if (this.isValidObject(company)) {
        this.$router.push({
          name: 'CompanyDetail',
          params: { id: company.id }
        })
      }
    },

    clearUrlQueryParam () {
      window.setTimeout(() => {
        this.$router.push(this.$route.path).catch(() => {})
      }, 100)
    },

    handleActiveTab () {
      if (this.tabUrlParam === 'company') {
        this.activeTab = 0
      }

      if (this.tabUrlParam === 'companyGroup') {
        this.activeTab = 1
      }

      this.clearUrlQueryParam()
    }
  },

  watch: {
    selectedCompany (company) {
      this.redirectToCompany(company)
    }
  },

  mounted () {
    this.handleActiveTab()
  }
}
</script>

<style lang="scss">
.route--company {

  .page__content,
  .v-tabs-reports,
  .v-tabs-reports .v-window,
  .v-tabs-reports .v-window .v-window__container,
  .v-tabs-reports .v-window .v-window__container .v-window-item,
  .v-tabs-reports .v-window .v-window__container .v-window-item > div {
    height: 100%;
  }

  .v-tabs-reports__hidden {

    .v-tabs__bar {
      display: none !important;
    }
  }
}
</style>
